// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__cqfYz","content":"index_content__sIoDL","imgItem":"index_imgItem__wNJSQ","titleItem":"index_titleItem__uwiLQ","shadow":"index_shadow__larlk"};